import { apiClient } from '@shared/api/client';

/**
 * Entity 목록 조회 (공통 엔드포인트)
 */
export const getEntities = async () => {
  const response = await apiClient.get('/startTask/common/entities');
  return response;
};

/**
 * Entity별 Controller 목록 조회
 * @param entityCd - Entity 코드
 */
export const getControllersByEntity = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/controllers-by-entity/${entityCd}`);
  return response;
};

/**
 * Controller의 전체 정보 조회 (Controller Cessation 전용)
 * @param entityCd - Entity 코드
 * @param registrableControllerId - Controller ID
 */
export const getControllerDetail = async (entityCd: string, registrableControllerId: string) => {
  const response = await apiClient.get(`/startTask/controller-cessation/controller-detail/${entityCd}/${registrableControllerId}`);
  return response;
};

/**
 * Controller의 BECOMING_DATE 조회 (deprecated - getControllerDetail 사용 권장)
 * @param entityCd - Entity 코드
 * @param registrableControllerId - Controller ID
 */
export const getControllerBecomingDate = async (entityCd: string, registrableControllerId: string) => {
  // 이 함수는 더 이상 사용하지 않음 (getControllerDetail 사용)
  const response = await getControllerDetail(entityCd, registrableControllerId);
  const responseData = (response as any).data || response;
  const controller = responseData?.controller || responseData?.data?.controller || null;
  return {
    ...response,
    data: {
      becomingDate: controller?.BECOMING_DATE || controller?.becomingDate || ''
    }
  };
};

/**
 * Controller Cessation Task 생성
 * @param data - Task 생성 데이터
 */
export interface CreateControllerCessationTaskRequest {
  entityCd: string;
  taskTypeCd: string;
  taskTypeName: string;
  taskTitle: string;
  taskFlow: {
    createDocument: boolean;
    requestTSign: boolean;
    proceedWithEFiling: boolean;
  };
  templateIds?: string[];
  officerData?: {
    controllerName?: string;
    controllerCode?: string;
    dateOfAppointed?: string;
    dateOfCessation?: string;
    reasonForCessation?: string;
    // Individual 필드
    nationalityCd?: string;
    identityCardOrPassport?: string;
    dateOfBirth?: string;
    aliases?: string;
    // Corporate 필드
    acraUen?: string;
    nonAcraUen?: string;
    legalForm?: string;
    jurisdiction?: string;
    incorporationStatute?: string;
    corporateEntityRegister?: string;
    // Address 필드
    addressTypeCd?: string;
    postalCode?: string;
    blockHouseNo?: string;
    streetName?: string;
    level?: string;
    unit?: string;
    buildingEstateName?: string;
    foreignAddressLine1?: string;
    foreignAddressLine2?: string;
    // Contact 필드
    emailAddress?: string;
    countryCode?: string;
    areaCode?: string;
    mobileNo?: string;
  };
}

export interface CreateControllerCessationTaskResponse {
  data: {
    taskId: number;
    taskTitle: string;
    templateMaps: Array<{
      tmpId: string;
      mapId: number;
    }>;
    docCustSaves: Array<{
      tmpId: string;
      mapId: number;
      saveId: number;
    }>;
    validation: {
      isValid: boolean;
      missingFields: Array<{
        field: string;
        label: string;
        category: string;
      }>;
    };
  };
  message: string;
}

export const createControllerCessationTask = async (
  data: CreateControllerCessationTaskRequest
) => {
  const response = await apiClient.post('/startTask/controller-cessation/tasks', data);
  return response;
};

/**
 * Task의 E-Filing 필수값 검증
 * @param taskId - Task ID
 */
export const validateControllerCessationTask = async (taskId: number) => {
  const response = await apiClient.get(`/startTask/controller-cessation/validate/${taskId}`);
  return response;
};

